import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Info } from 'lucide-react';

interface NotFoundStateProps {}

/**
 * Component to display a not found state
 */
export const NotFoundState: React.FC<NotFoundStateProps> = () => {
  return (
    <div className="container max-w-7xl mx-auto py-6 px-6">
      <Card className="shadow-md border-muted">
        <CardHeader>
          <CardTitle className="flex items-center">
            <Info className="mr-2 h-5 w-5 text-muted-foreground" />
            Not Found
          </CardTitle>
          <CardDescription className="mt-2">
            The requested item could not be found or may have been deleted.
          </CardDescription>
        </CardHeader>
      </Card>
    </div>
  );
};

export default NotFoundState;
